import { Record } from "../../../fable_modules/fable-library-js.4.24.0/Types.js";
import { BazaarCategory, Provider, Provider_$reflection, BazaarCategory_$reflection } from "../../../Shopfoo.Domain.Types/Catalog.js";
import { lambda_type, unit_type, option_type, record_type, int32_type, string_type, class_type } from "../../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Page, Router_navigatePage, Router_goToUrl as Router_goToUrl_1, $007CPageUrl$007C as $007CPageUrl$007C_1, Page_$reflection } from "../../../Routing.js";
import { createElement } from "react";
import React from "react";
import { structuralHash, stringHash, comparePrimitives, safeHash, compare, equals, createObj } from "../../../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../../../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { sortBy as sortBy_1, isEmpty, length, tryFind, singleton as singleton_1, append as append_1, ofArray } from "../../../fable_modules/fable-library-js.4.24.0/List.js";
import { map as map_1, sort, collect, sortBy, empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Filters__ClearSearchSort, Filters__ToBooks, Filters, Filters__ToBooksWithTag_6DFDD678, Filters__get_BooksTag, Filters__ToBooksWithAuthor_1D9C746C, Filters__get_BooksAuthorId, Filters__ToBazaar_Z3BF3079, Filters__get_BazaarCategory } from "../../../Filters.js";
import { Router_goToUrl, $007CPageUrl$007C } from "../../../Routing.js";
import { defaultArg, unwrap, map, defaultArgWith } from "../../../fable_modules/fable-library-js.4.24.0/Option.js";
import { RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_encodeParts } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { icon as icon_2 } from "../../../Components/Icon.js";
import { reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { List_countBy, distinct } from "../../../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { empty as empty_1 } from "../../../fable_modules/fable-library-js.4.24.0/Set.js";
import { FilterAction$1, Filter_FilterTab_Z754DA2F2 } from "../../../Components/FilterTab.js";
import { TranslationPages_Home__get_Bazaar, AppTranslations__get_Home, TranslationPages_Home__get_Books, TranslationPages_Product__StoreCategoryOf_Z2CEE261C, TranslationPages_Product__get_HighlightMatches, TranslationPages_Product__get_MatchCase, TranslationPages_Product__BookSearchLimit_Z37302880, TranslationPages_Product__get_NoBooksFound, TranslationPages_Product__get_SearchBooks, TranslationPages_Product__get_Tags, AppTranslations__get_Product, TranslationPages_Product__get_Authors } from "../../../Shopfoo.Shared/Translations.js";
import pen_fancy from "@iconify-icons/fa6-solid/pen-fancy";
import tags_1 from "@iconify-icons/fa6-solid/tags";
import magnifying_glass from "@iconify-icons/fa6-solid/magnifying-glass";
import { SearchBox_SearchBox_3A9FAC5, SearchCompletionStatus, SearchButtonProps, AfterSearch } from "../../../Components/SearchBox.js";
import { toKebab, $007CNotEmpty$007C_$007C } from "../../../Shopfoo.Common/String.js";
import { Option_ofNonNullOrWhitespace } from "../../../Shopfoo.Common/Common.js";
import { Highlighting_ActiveIf_Z1FBCCD16, Highlighting as Highlighting_1, CaseSensitiveIf, CaseMatching as CaseMatching_1, SearchConfig } from "../../../Search.js";
import { interpolate, toText } from "../../../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpMap__get_Item, ofList } from "../../../fable_modules/fable-library-js.4.24.0/Map.js";
import book_1 from "@iconify-icons/fa6-solid/book";
import store from "@iconify-icons/fa6-solid/store";
import gem from "@iconify-icons/fa6-solid/gem";
import shirt from "@iconify-icons/fa6-solid/shirt";
import tv from "@iconify-icons/fa6-solid/tv";

class BazaarTabProps extends Record {
    constructor(Category, Icon, Text$, ProductCount) {
        super();
        this.Category = Category;
        this.Icon = Icon;
        this.Text = Text$;
        this.ProductCount = (ProductCount | 0);
    }
}

function BazaarTabProps_$reflection() {
    return record_type("Shopfoo.Client.Pages.Product.Index.FilterBar.BazaarTabProps", [], BazaarTabProps, () => [["Category", BazaarCategory_$reflection()], ["Icon", class_type("Glutinum.Iconify.IconifyIcon", undefined, IconifyIcon)], ["Text", string_type], ["ProductCount", int32_type]]);
}

class ProviderTabProps extends Record {
    constructor(Provider, SelectedProvider, SelectProvider, Text$, Icon, ProductCount, TargetPage) {
        super();
        this.Provider = Provider;
        this.SelectedProvider = SelectedProvider;
        this.SelectProvider = SelectProvider;
        this.Text = Text$;
        this.Icon = Icon;
        this.ProductCount = (ProductCount | 0);
        this.TargetPage = TargetPage;
    }
}

function ProviderTabProps_$reflection() {
    return record_type("Shopfoo.Client.Pages.Product.Index.FilterBar.ProviderTabProps", [], ProviderTabProps, () => [["Provider", Provider_$reflection()], ["SelectedProvider", option_type(Provider_$reflection())], ["SelectProvider", lambda_type(Provider_$reflection(), unit_type)], ["Text", string_type], ["Icon", class_type("Glutinum.Iconify.IconifyIcon", undefined, IconifyIcon)], ["ProductCount", int32_type], ["TargetPage", Page_$reflection()]]);
}

class Tab {
    constructor(filters, selectedProvider, translations, searchedBooks, onSearchBooks, onClearSearchedBooks) {
        this.filters = filters;
        this.selectedProvider = selectedProvider;
        this.translations = translations;
        this.searchedBooks = searchedBooks;
        this.onSearchBooks = onSearchBooks;
        this.onClearSearchedBooks = onClearSearchedBooks;
    }
}

function Tab_$reflection() {
    return class_type("Shopfoo.Client.Pages.Product.Index.FilterBar.Tab", undefined, Tab);
}

function Tab_$ctor_Z74390E1D(filters, selectedProvider, translations, searchedBooks, onSearchBooks, onClearSearchedBooks) {
    return new Tab(filters, selectedProvider, translations, searchedBooks, onSearchBooks, onClearSearchedBooks);
}

function Tab__divider_Z721C83C5(_, key) {
    return createElement("div", createObj(Helpers_combineClasses("divider", ofArray([["className", "divider-horizontal"], ["key", `${key}`], ["className", "mx-1"]]))));
}

function Tab__bazaarCategory_Z4532DED8(_, props) {
    return createElement("a", createObj(Helpers_combineClasses("tab", toList(delay(() => {
        const key = `tab-bazaar-category-${Tab__reactKeyOf_1505(_, props.Category)}`;
        return append(singleton(["key", key]), delay(() => {
            let pageUrl_1, queryString_1;
            const isActive = equals(Filters__get_BazaarCategory(_.filters), props.Category);
            return append(isActive ? append(singleton(["className", "tab-active"]), delay(() => {
                let pageUrl, queryString;
                return (pageUrl = $007CPageUrl$007C(Tab__pageWithFilters_Z3D62F06A(_, Filters__ToBazaar_Z3BF3079)), ofArray([["href", (queryString = pageUrl.Query, defaultArgWith(map((tupledArg) => RouterModule_encodeParts(append_1(tupledArg[0], singleton_1(tupledArg[1] + RouterModule_encodeQueryString(queryString))), 2), RouterModule_trySeparateLast(pageUrl.Segments)), () => RouterModule_encodeParts(singleton_1(RouterModule_encodeQueryString(queryString)), 2)))], ["onClick", (e) => {
                    Router_goToUrl(e);
                }]]));
            })) : ((pageUrl_1 = $007CPageUrl$007C(Tab__pageWithFilters_Z3D62F06A(_, (_arg_3) => Filters__ToBazaar_Z3BF3079(_arg_3, props.Category))), ofArray([["href", (queryString_1 = pageUrl_1.Query, defaultArgWith(map((tupledArg_1) => RouterModule_encodeParts(append_1(tupledArg_1[0], singleton_1(tupledArg_1[1] + RouterModule_encodeQueryString(queryString_1))), 2), RouterModule_trySeparateLast(pageUrl_1.Segments)), () => RouterModule_encodeParts(singleton_1(RouterModule_encodeQueryString(queryString_1)), 2)))], ["onClick", (e_1) => {
                Router_goToUrl(e_1);
            }]]))), delay(() => {
                let elems_2, elems_1, elems;
                return singleton((elems_2 = [createElement("div", createObj(Helpers_combineClasses("indicator", ofArray([["key", `${key}-indicator`], (elems_1 = [createElement("div", createObj(Helpers_combineClasses("indicator-item", ofArray([["key", `${key}-badge`], ["className", "badge badge-sm badge-primary badge-soft px-1"], ["children", props.ProductCount]])))), createElement("div", createObj(ofArray([["key", `${key}-content`], ["className", "flex items-center gap-2 pr-3"], (elems = toList(delay(() => append(singleton(icon_2(props.Icon)), delay(() => append(singleton(`${props.Text}`), delay(() => (isActive ? singleton(createElement("span", {
                    key: `${key}-tab-close-button`,
                    className: "btn btn-ghost btn-sm btn-circle",
                    children: "✕",
                })) : empty()))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))]));
            }));
        }));
    })))));
}

function Tab__booksAuthors_Z522604AA(_, products) {
    const authors = toList(sortBy((_arg) => _arg.Name, distinct(collect((p) => {
        const matchValue = p.Category;
        if (matchValue.tag === 1) {
            return matchValue.fields[0].Authors;
        }
        else {
            return empty_1({
                Compare: compare,
            });
        }
    }, products), {
        Equals: equals,
        GetHashCode: safeHash,
    }), {
        Compare: comparePrimitives,
    }));
    let selectedAuthor;
    const matchValue_1 = Filters__get_BooksAuthorId(_.filters);
    if (matchValue_1 == null) {
        selectedAuthor = undefined;
    }
    else {
        const selectedAuthorId = matchValue_1;
        selectedAuthor = tryFind((author) => equals(author.OLID, selectedAuthorId), authors);
    }
    return createElement(Filter_FilterTab_Z754DA2F2, {
        key: "filter-tab-authors",
        $key: "filter-tab-authors",
        label: TranslationPages_Product__get_Authors(AppTranslations__get_Product(_.translations)),
        iconifyIcon: pen_fancy,
        items: authors,
        selectedItem: unwrap(selectedAuthor),
        formatItem: (_arg_1) => _arg_1.Name,
        onSelect: new FilterAction$1(1, [(author_1) => Tab__pageWithFilters_Z3D62F06A(_, (_arg_2) => Filters__ToBooksWithAuthor_1D9C746C(_arg_2, author_1.OLID))]),
        onReset: new FilterAction$1(1, [() => Tab__pageWithFilters_Z3D62F06A(_, (_arg_3) => Filters__ToBooksWithAuthor_1D9C746C(_arg_3, undefined))]),
    });
}

function Tab__booksTags_Z522604AA(_, products) {
    const tags = toList(sort(distinct(collect((p) => {
        const matchValue = p.Category;
        if (matchValue.tag === 1) {
            return matchValue.fields[0].Tags;
        }
        else {
            return empty_1({
                Compare: comparePrimitives,
            });
        }
    }, products), {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: stringHash,
    }), {
        Compare: comparePrimitives,
    }));
    return createElement(Filter_FilterTab_Z754DA2F2, {
        key: "filter-tab-tags",
        $key: "filter-tab-tags",
        label: TranslationPages_Product__get_Tags(AppTranslations__get_Product(_.translations)),
        iconifyIcon: tags_1,
        items: tags,
        selectedItem: unwrap(Filters__get_BooksTag(_.filters)),
        formatItem: (x_3) => x_3,
        onSelect: new FilterAction$1(1, [(tag) => Tab__pageWithFilters_Z3D62F06A(_, (_arg) => Filters__ToBooksWithTag_6DFDD678(_arg, tag))]),
        onReset: new FilterAction$1(1, [() => Tab__pageWithFilters_Z3D62F06A(_, (_arg_1) => Filters__ToBooksWithTag_6DFDD678(_arg_1, undefined))]),
    });
}

function Tab__provider_Z3943521E(_, props) {
    const pageUrl = $007CPageUrl$007C_1(props.TargetPage);
    const key = `tab-provider-${Tab__reactKeyOf_1505(_, props.Provider)}`;
    return createElement("a", createObj(Helpers_combineClasses("tab", toList(delay(() => append(singleton(["key", key]), delay(() => {
        let elems_2, elems_1;
        return append(singleton((elems_2 = [createElement("div", createObj(Helpers_combineClasses("indicator", ofArray([["key", `${key}-count-indicator`], (elems_1 = toList(delay(() => append(equals(props.SelectedProvider, props.Provider) ? singleton(createElement("div", createObj(Helpers_combineClasses("indicator-item", ofArray([["key", `${key}-count-badge`], ["className", "badge badge-sm badge-primary badge-soft px-1"], ["children", props.ProductCount]]))))) : empty(), delay(() => {
            let elems;
            return singleton(createElement("div", createObj(ofArray([["key", `${key}-count-badge-content`], ["className", "flex items-center gap-2 pr-3"], (elems = [icon_2(props.Icon), `${props.Text}`], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])), delay(() => {
            let queryString;
            return equals(props.SelectedProvider, props.Provider) ? singleton(["className", "tab-active"]) : append(singleton(["href", (queryString = pageUrl.Query, defaultArgWith(map((tupledArg) => RouterModule_encodeParts(append_1(tupledArg[0], singleton_1(tupledArg[1] + RouterModule_encodeQueryString(queryString))), 2), RouterModule_trySeparateLast(pageUrl.Segments)), () => RouterModule_encodeParts(singleton_1(RouterModule_encodeQueryString(queryString)), 2)))]), delay(() => singleton(["onClick", (ev) => {
                props.SelectProvider(props.Provider);
                Router_goToUrl_1(ev);
            }])));
        }));
    })))))));
}

function Tab__toggle_5D122E0A(_, key, text, isChecked, onCheckedChange) {
    let elems_1, elems;
    return createElement("fieldset", createObj(Helpers_combineClasses("fieldset", ofArray([["key", `${key}-fieldset`], (elems_1 = [createElement("label", createObj(Helpers_combineClasses("fieldset-label", ofArray([["key", `${key}-label`], ["className", "text-sm whitespace-nowrap"], (elems = [createElement("input", createObj(Helpers_combineClasses("toggle", ofArray([["type", "checkbox"], ["key", `${key}-toggle`], ["checked", isChecked], ["onChange", (ev) => {
        onCheckedChange(ev.target.checked);
    }]])))), `${text}`], ["children", reactApi.Children.toArray(Array.from(elems))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
}

function Tab__get_search(this$) {
    let data, data_1, elems;
    const searchTerm_1 = defaultArg(this$.filters.Search.Term, "");
    let searchMoreButtonProps;
    const matchValue = this$.selectedProvider;
    let matchResult, searchTerm_2;
    if (matchValue != null) {
        if (matchValue.tag === 1) {
            if ($007CNotEmpty$007C_$007C(searchTerm_1) != null) {
                matchResult = 0;
                searchTerm_2 = searchTerm_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const matchValue_2 = this$.searchedBooks;
            let matchResult_1, apiError, data_2;
            switch (matchValue_2.tag) {
                case 1: {
                    matchResult_1 = 1;
                    break;
                }
                case 2: {
                    matchResult_1 = 2;
                    apiError = matchValue_2.fields[0];
                    break;
                }
                case 3: {
                    if (isEmpty(matchValue_2.fields[0].Items)) {
                        if (matchValue_2.fields[0].TotalCount === 0) {
                            matchResult_1 = 3;
                        }
                        else if ((data = matchValue_2.fields[0], data.TotalCount > length(data.Items))) {
                            matchResult_1 = 4;
                            data_2 = matchValue_2.fields[0];
                        }
                        else {
                            matchResult_1 = 5;
                        }
                    }
                    else if ((data_1 = matchValue_2.fields[0], data_1.TotalCount > length(data_1.Items))) {
                        matchResult_1 = 4;
                        data_2 = matchValue_2.fields[0];
                    }
                    else {
                        matchResult_1 = 5;
                    }
                    break;
                }
                default:
                    matchResult_1 = 0;
            }
            switch (matchResult_1) {
                case 0: {
                    searchMoreButtonProps = (new SearchButtonProps(1, [magnifying_glass, TranslationPages_Product__get_SearchBooks(AppTranslations__get_Product(this$.translations)), () => {
                        this$.onSearchBooks(searchTerm_2);
                        return new AfterSearch(false);
                    }]));
                    break;
                }
                case 1: {
                    searchMoreButtonProps = (new SearchButtonProps(2, []));
                    break;
                }
                case 2: {
                    searchMoreButtonProps = (new SearchButtonProps(3, [new SearchCompletionStatus(2, [apiError.ErrorMessage])]));
                    break;
                }
                case 3: {
                    searchMoreButtonProps = (new SearchButtonProps(3, [new SearchCompletionStatus(1, [TranslationPages_Product__get_NoBooksFound(AppTranslations__get_Product(this$.translations))])]));
                    break;
                }
                case 4: {
                    searchMoreButtonProps = (new SearchButtonProps(3, [new SearchCompletionStatus(1, [TranslationPages_Product__BookSearchLimit_Z37302880(AppTranslations__get_Product(this$.translations), length(data_2.Items), data_2.TotalCount)])]));
                    break;
                }
                default:
                    searchMoreButtonProps = (new SearchButtonProps(3, [new SearchCompletionStatus(0, [])]));
            }
            break;
        }
        default:
            searchMoreButtonProps = (new SearchButtonProps(0, []));
    }
    return createElement("div", createObj(ofArray([["key", "search-bar"], ["className", "flex items-center gap-3 ml-auto"], (elems = [createElement(SearchBox_SearchBox_3A9FAC5, {
        key: "search-box",
        $key: "search-box",
        value: searchTerm_1,
        onChange: (term) => {
            this$.onClearSearchedBooks();
            const searchTerm = Option_ofNonNullOrWhitespace(term);
            Router_navigatePage(Tab__pageWithFilters_Z3D62F06A(this$, (filters_2) => {
                let bind$0040_2;
                return new Filters(filters_2.CategoryFilters, (bind$0040_2 = filters_2.Search, new SearchConfig(bind$0040_2.Columns, bind$0040_2.CaseMatching, bind$0040_2.Highlighting, searchTerm)), filters_2.SortBy);
            }));
        },
        translations: this$.translations,
        onKeyDown: (ev) => {
            let matchResult_2, onSearch_1;
            if (searchMoreButtonProps.tag === 1) {
                if (ev.key === "Enter") {
                    matchResult_2 = 0;
                    onSearch_1 = searchMoreButtonProps.fields[2];
                }
                else {
                    matchResult_2 = 1;
                }
            }
            else {
                matchResult_2 = 1;
            }
            switch (matchResult_2) {
                case 0: {
                    ev.preventDefault();
                    onSearch_1();
                    break;
                }
                case 1: {
                    break;
                }
            }
        },
        searchMoreButtonProps: searchMoreButtonProps,
        className: "ml-2",
    }), Tab__toggle_5D122E0A(this$, "matchCase", TranslationPages_Product__get_MatchCase(AppTranslations__get_Product(this$.translations)), equals(this$.filters.Search.CaseMatching, new CaseMatching_1(0, [])), (b) => {
        Router_navigatePage(Tab__pageWithFilters_Z3D62F06A(this$, (filters) => {
            let bind$0040;
            return new Filters(filters.CategoryFilters, (bind$0040 = filters.Search, new SearchConfig(bind$0040.Columns, CaseSensitiveIf(b), bind$0040.Highlighting, bind$0040.Term)), filters.SortBy);
        }));
    }), Tab__toggle_5D122E0A(this$, "highlightMatches", TranslationPages_Product__get_HighlightMatches(AppTranslations__get_Product(this$.translations)), equals(this$.filters.Search.Highlighting, new Highlighting_1(0, [])), (b_1) => {
        Router_navigatePage(Tab__pageWithFilters_Z3D62F06A(this$, (filters_1) => {
            let bind$0040_1;
            return new Filters(filters_1.CategoryFilters, (bind$0040_1 = filters_1.Search, new SearchConfig(bind$0040_1.Columns, bind$0040_1.CaseMatching, Highlighting_ActiveIf_Z1FBCCD16(b_1), bind$0040_1.Term)), filters_1.SortBy);
        }));
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function Tab__reactKeyOf_1505(this$, x) {
    return toKebab(toText(interpolate("%A%P()", [x])));
}

export function Tab__pageWithFilters_Z3D62F06A(this$, changeFilters) {
    return new Page(5, [changeFilters(this$.filters)]);
}

export function ProductFilterBar(productFilterBarInputProps) {
    let elems;
    const translations = productFilterBarInputProps.translations;
    const onClearSearchedBooks = productFilterBarInputProps.onClearSearchedBooks;
    const onSearchBooks = productFilterBarInputProps.onSearchBooks;
    const searchedBooks = productFilterBarInputProps.searchedBooks;
    const selectProvider = productFilterBarInputProps.selectProvider;
    const selectedProvider = productFilterBarInputProps.selectedProvider;
    const products = productFilterBarInputProps.products;
    const filters = productFilterBarInputProps.filters;
    const key = productFilterBarInputProps.$key;
    const tab = Tab_$ctor_Z74390E1D(filters, selectedProvider, translations, searchedBooks, onSearchBooks, onClearSearchedBooks);
    const productCountByCategory = ofList(List_countBy((p) => {
        const matchValue = p.Category;
        if (matchValue.tag === 0) {
            return matchValue.fields[0].Category;
        }
        else {
            return undefined;
        }
    }, products, {
        Equals: equals,
        GetHashCode: structuralHash,
    }), {
        Compare: compare,
    });
    const bazaarTab = (category, icon) => (new BazaarTabProps(category, icon, TranslationPages_Product__StoreCategoryOf_Z2CEE261C(AppTranslations__get_Product(translations), category), FSharpMap__get_Item(productCountByCategory, category)));
    const providerTab = (provider, text, icon_1, changeFilters) => (new ProviderTabProps(provider, selectedProvider, selectProvider, text, icon_1, length(products), new Page(5, [changeFilters(filters)])));
    return createElement("div", createObj(Helpers_combineClasses("tabs", ofArray([["className", "tabs-border"], ["key", `${key}-content`], ["className", "pb-2 border-b border-gray-200"], (elems = toList(delay(() => append(map_1((props) => Tab__provider_Z3943521E(tab, props), sortBy_1((_arg_2) => _arg_2.Text, ofArray([providerTab(new Provider(1, []), TranslationPages_Home__get_Books(AppTranslations__get_Home(translations)), book_1, (_arg) => Filters__ToBooks(Filters__ClearSearchSort(_arg))), providerTab(new Provider(0, []), TranslationPages_Home__get_Bazaar(AppTranslations__get_Home(translations)), store, (_arg_1) => Filters__ToBazaar_Z3BF3079(Filters__ClearSearchSort(_arg_1)))]), {
        Compare: comparePrimitives,
    })), delay(() => append(singleton(Tab__divider_Z721C83C5(tab, "provider-divider")), delay(() => {
        const matchValue_1 = selectedProvider;
        if (matchValue_1 != null) {
            return (matchValue_1.tag === 1) ? append(singleton(Tab__booksAuthors_Z522604AA(tab, products)), delay(() => append(singleton(Tab__booksTags_Z522604AA(tab, products)), delay(() => singleton(Tab__get_search(tab)))))) : append(map_1((props_1) => Tab__bazaarCategory_Z4532DED8(tab, props_1), sortBy_1((_arg_3) => _arg_3.Text, ofArray([bazaarTab(new BazaarCategory(2, []), gem), bazaarTab(new BazaarCategory(0, []), shirt), bazaarTab(new BazaarCategory(1, []), tv)]), {
                Compare: comparePrimitives,
            })), delay(() => singleton(Tab__get_search(tab))));
        }
        else {
            return empty();
        }
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))));
}

